

















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class NotificationAlert extends Vue {
  @Prop() value!: boolean
  @Prop({ default: 3000 }) timeout!: number
  @Prop() type!: string
  @Prop() outlined!: boolean
  @Prop() message!: string
  timerId: number | null = null

  @Watch('value')
  setTimer() {
    if (!this.value) return
    if (this.timerId) clearTimeout(this.timerId)
    setTimeout(() => {
      this.$emit('input', false)
    }, this.timeout)
  }
}
